import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const LandingPage = lazy(() => import('../pages/landing/page'));
const QuemSomosPage = lazy(() => import('../pages/quem-somos/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

// Blog Posts
const ComoVenderCartaPost = lazy(() => import('../pages/blog/posts/como-vender-carta-de-consorcio/page'));
const ConsorcioImoveisPost = lazy(() => import('../pages/blog/posts/consorcio-imoveis/page'));
const ConsorcioVeiculosPost = lazy(() => import('../pages/blog/posts/consorcio-veiculos/page'));
const ConsorcioXFinanciamentoPost = lazy(() => import('../pages/blog/posts/consorcio-x-financiamento/page'));
const LanceConsorcioPost = lazy(() => import('../pages/blog/posts/lance-consorcio/page'));
const BlogCategoriaPage = lazy(() => import('../pages/blog/categoria/page'));
const MelhoresAdministradorasPost = lazy(() => import('../pages/blog/posts/melhores-administradoras/page'));
const ConsorcioServicosPost = lazy(() => import('../pages/blog/posts/consorcio-servicos/page'));
const SitemapPage = lazy(() => import('../pages/sitemap/page'));
const VenderCartaPage = lazy(() => import('../pages/vender-carta/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/quem-somos',
    element: <QuemSomosPage />,
  },
  {
    path: '/landing',
    element: <LandingPage />,
  },
  {
    path: '/blog',
    element: <BlogPage />,
  },
  {
    path: '/blog/como-vender-carta-de-consorcio',
    element: <ComoVenderCartaPost />,
  },
  {
    path: '/blog/consorcio-imoveis',
    element: <ConsorcioImoveisPost />,
  },
  {
    path: '/blog/consorcio-veiculos',
    element: <ConsorcioVeiculosPost />,
  },
  {
    path: '/blog/consorcio-x-financiamento',
    element: <ConsorcioXFinanciamentoPost />,
  },
  {
    path: '/blog/lance-consorcio',
    element: <LanceConsorcioPost />,
  },
  {
    path: '/blog/melhores-administradoras-consorcio',
    element: <MelhoresAdministradorasPost />,
  },
  {
    path: '/blog/consorcio-servicos',
    element: <ConsorcioServicosPost />,
  },
  {
    path: '/blog/categoria/:slug',
    element: <BlogCategoriaPage />,
  },
  {
    path: '/vender-carta',
    element: <VenderCartaPage />,
  },
  {
    path: '/sitemap',
    element: <SitemapPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;